import React, { useState } from 'react'
import { AlertProvider } from './global-whatsapp/context/AlertContext';
import { Route, Routes } from 'react-router'

import RootPage from './global-whatsapp/app/pages/RootPage';
import PortalLandingPage from './global-whatsapp/app/pages/landing/PortalLandingPage';
import GrievanceLandingPage from './global-whatsapp/app/pages/landing/GrievanceLandingPage';
import ChatbotLandingPage from './global-whatsapp/app/pages/landing/ChatbotLandingPage';

import ComplainFormPage from './global-whatsapp/app/pages/ComplainFormPage';
import ComplaintDetailsPage from './global-whatsapp/app/pages/ComplaintDetailsPage';
import ComplaintListPage from './global-whatsapp/app/pages/ComplaintListPage';

import NotFound404 from './global-whatsapp/app/pages/errorPages/NotFound404';
import ChatBotPage from './global-whatsapp/app/pages/ChatBotPage';
import InstallPrompt from './global-whatsapp/app/components/InstallPrompt';
import ChatPopup from './global-whatsapp/app/components/chat/ChatPopup';
import ComplaintDashboardPage from './global-whatsapp/app/pages/ComplaintDashboardPage';

import EmergencyPage from './global-whatsapp/app/pages/EmergencyPage';
import AboutUsPage from './global-whatsapp/app/pages/AboutUsPage';
import { ChatConversationProvider } from './global-whatsapp/context/ConversationContext';
import NearMePage from './global-whatsapp/app/pages/NearMePage';


function App() {

    

    return (
        <>
        <AlertProvider>
        <ChatConversationProvider>
            <Routes>
                {localStorage.portalUrl === undefined && <Route path="/" element={ <RootPage/> } />}
                <Route path="/portal/:portalId" element={ <PortalLandingPage/> } />
                <Route path="/portal/:portalId/gid/:gid" element={ <GrievanceLandingPage /> } />
                <Route path="/chatbot/:portalId" element={ <ChatbotLandingPage /> } />

            {localStorage.portalUrl !== undefined &&
                <>
                <Route path="/" element={ <ChatBotPage/> } />
                <Route path="/chatbot" element={ <ChatBotPage/> } />
                <Route path="/complaint" element={ <ComplaintDashboardPage /> } />
                <Route path="/complaint/form" element={ <ComplainFormPage /> } />
                <Route path="/complaint/form/:grievanceType" element={ <ComplainFormPage /> } />
                <Route path="/complaint/list" element={ <ComplaintListPage/> } />
                <Route path="/complaint/details/:gid" element={ <ComplaintDetailsPage /> } /> 
                <Route path="/emergency" element={ <EmergencyPage /> } />
                <Route path="/about" element={ <AboutUsPage /> } />

                {/*<Route path="/nearme" element={ <NearMePage /> } /> */}
                </>
            }
                
                <Route path="*" element={<NotFound404/>} />
            </Routes>
        </ChatConversationProvider>
        </AlertProvider>
        
        </>
    )
}
export default App




{/*
<Route path="/portal/:portalId" element={ <PortalLandingPage/> } /> 
<Route path="/portal/:portalId/gid/:gid" element={ <PortalGrievanceLandingPage/> } /> 
<Route path="/portal/complaint/details/:gid" element={ <ComplaintDetailsPage/> } />
<Route path="/portal" element={ <PortalDashboardPage/> } />
<Route path="/portal/complaint/form" element={ <ComplaintFormPage/> } />
<Route path="/portal/complaint/list" element={ <ComplaintListPage/> } />
{/* Chat Bot Related Work Start  
<Route path="/chatbot/:portalId" element={ <ChatBotInitPage/> } /> 
<Route path="/chatbot" element={ <ChatPage/> } />
<Route path="/chatbot2" element={ <ChatPage2 /> } /> 
{/* Chat Bot Related Work End  
*/}